import React from 'react'

import { useFormContext } from './useForm'
import { useFormFieldArray, FormFieldArrayProvider } from './useFormFieldArray'

export const FormFieldArray = ({ name, keyName, children, ...props }) => {
  const { control } = useFormContext()
  const context = useFormFieldArray({ name, keyName, control })
  const { fields, ...rest } = context

  return <FormFieldArrayProvider value={context}>{children(fields, rest)}</FormFieldArrayProvider>
}

export default FormFieldArray
